import { render, staticRenderFns } from "./ys-register-popup.vue?vue&type=template&id=ddcf0cc2&scoped=true"
import script from "./ys-register-popup.vue?vue&type=script&lang=js"
export * from "./ys-register-popup.vue?vue&type=script&lang=js"
import style0 from "./ys-register-popup.vue?vue&type=style&index=0&id=ddcf0cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcf0cc2",
  null
  
)

export default component.exports